module.exports = __webpack_public_path__ + "media/pil_vit.27575e9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pil_vit.svg
// module id = 502
// module chunks = 0